import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import ReactMarkdown from 'react-markdown';

import { CSSTransitionGroup } from 'react-transition-group';

class ProjectTextCard extends Component {
  RouterLink(props) {
    return props.href.match(/^(https?:)?\/\//)
      ? <a href={props.href}>
          {props.children}
        </a>
      : <Link to={props.href}>
          {props.children}
        </Link>;
  }

  render() {
    const { body } = this.props;

    const items = body.map((key, index) =>
      <ReactMarkdown
        source={key.value}
        renderers={{ Link: this.RouterLink }}
        key={index}
        className={key.type}
      />
    );

    return (
      <CSSTransitionGroup
        component="div"
        className="card-wrapper"
        transitionName="textFadeInUp"
        transitionEnter={true}
        transitionEnterTimeout={600}
        transitionLeave={false}
        transitionAppear={true}
        transitionAppearTimeout={600}
      >
        <div className="card" key={Math.random()}>
          {items}
        </div>
      </CSSTransitionGroup>
    );
  }
}

ProjectTextCard.propTypes = {
  body: PropTypes.array
};

export default ProjectTextCard;



// WEBPACK FOOTER //
// ./src/components/ProjectTextCard.js